(function(window, angular, undefined) {
    angular.module('formApp')
    .factory('moment', ['$window', function ($window) {
        return $window.moment;
    }]);
        
})(window, window.angular);